<template>
    <div>
        <v-container fluid class="d-print-none">
            <v-row no-gutters>
                <v-col cols="6">
                    <h1 class="headline font-weight-light mb-3">
                        DEFECTIVE PHA
                    </h1>
                </v-col>

                <v-col cols="6" class="text-right">
                    <v-btn
                        v-if="
                            team_name == 'INVENTORY' ||
                                (team_name == 'SVC' && role_name == 'Manager')
                        "
                        rounded
                        small
                        class="ml-5 mar-t-10"
                        color="amber"
                        @click="get_pending()"
                    >
                        <v-icon small class="mr-1"> mdi-magnify </v-icon>
                        Pending
                    </v-btn>
                    <span
                        v-if="
                            team_name == 'ODM' ||
                                team_name == 'INVENTORY' ||
                                team_name == 'SVC'
                        "
                    >
                        <v-btn
                            class="ml-2 mar-t-10"
                            small
                            rounded
                            color="success"
                            @click="export_data()"
                        >
                            export pending
                        </v-btn>
                    </span>
                    <v-btn
                        rounded
                        small
                        class="ml-5 mar-t-10"
                        @click="get_history()"
                        v-if="team_name != 'SVC'"
                    >
                        <v-icon small class="mr-1"> mdi-magnify </v-icon>
                        History
                    </v-btn>
                </v-col>
            </v-row>

            <v-card>
                <div>
                    <v-row>
                        <v-col cols="6" md="4" v-if="team_name != 'SVC'">
                            <v-text-field
                                class="ml-2"
                                outlined
                                dense
                                v-model="form_search_case"
                                @keyup="uppercase()"
                                @keyup.enter="func_search_case()"
                                label="Enter / Search Case "
                                prepend-inner-icon="mdi-magnify"
                            ></v-text-field>
                        </v-col>
                        <v-btn
                            fab
                            small
                            class="mt-3"
                            @click="func_search_case()"
                            v-if="
                                form_search_case && form_search_case.length > 0
                            "
                            ><v-icon>mdi-magnify</v-icon></v-btn
                        >

                        <v-spacer></v-spacer>
                        <v-col
                            cols="2"
                            class="text-right mr-2"
                            v-if="team_name != 'SVC'"
                        >
                            <span>Count : {{ checkbox.length }}</span>
                        </v-col>
                        <v-col
                            cols="4"
                            class="text-right mr-2"
                            v-if="team_name != 'SVC'"
                        >
                            <v-btn
                                color="success"
                                class="mr-2"
                                @click="save()"
                                small
                                :disabled="checkbox.length === 0"
                                rounded
                            >
                                <v-icon class="mr-1">mdi-content-save</v-icon>
                                Save</v-btn
                            >
                        </v-col>

                        <v-col cols="12" class="mar-t-20">
                            <v-simple-table class="table-inv">
                                <template v-slot:default>
                                    <thead>
                                        <tr class="col-tr-1">
                                            <th
                                                class="text-center"
                                                width="5%"
                                                v-if="team_name != 'SVC'"
                                            >
                                                <v-btn
                                                    :color="colorx"
                                                    rounded
                                                    small
                                                    @click="all()"
                                                    class="ml-4"
                                                >
                                                    All
                                                </v-btn>
                                            </th>
                                            <th class="text-center">#</th>
                                            <th class="text-center">Branch</th>
                                            <th class="text-center">Detail</th>
                                            <th class="text-center">CaseID</th>
                                            <th class="text-center">
                                                Job Type
                                            </th>
                                            <th class="text-center">
                                                Engineer
                                            </th>
                                            <th class="text-center">
                                                Onsite Date
                                            </th>
                                            <th class="text-center">
                                                Solution
                                            </th>
                                            <th class="text-center">
                                                SRFR Claim
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr
                                            v-for="(n, num) in data_main"
                                            :key="num"
                                        >
                                            <td
                                                class="text-center"
                                                v-if="team_name != 'SVC'"
                                            >
                                                <v-checkbox
                                                    v-model="checkbox"
                                                    label=""
                                                    color="green"
                                                    :value="n.defective_id"
                                                ></v-checkbox>
                                            </td>
                                            <td class="text-center">
                                                {{ num + 1 }}.
                                            </td>
                                            <td class="text-center">
                                                {{ n.branch_name }}
                                            </td>
                                            <td class="text-center">
                                                <v-chip
                                                    x-small
                                                    color="orange lighten-3"
                                                >
                                                    {{ n.part_name }}
                                                </v-chip>
                                                <br />
                                                <v-chip
                                                    x-small
                                                    color="teal lighten-3"
                                                    class="mt-1"
                                                >
                                                    {{ n.singlepart }}
                                                </v-chip>
                                            </td>
                                            <td class="text-center">
                                                {{ n.case_id }}
                                            </td>
                                            <td>
                                                {{ n.case_type }}
                                            </td>
                                            <td>
                                                {{ n.engineer_name }}
                                            </td>
                                            <td class="text-center">
                                                {{ n.onsite_date }}
                                            </td>
                                            <td>
                                                {{ n.solution }}
                                            </td>
                                            <td class="text-center">
                                                <v-chip
                                                    x-small
                                                    color="blue lighten-4"
                                                >
                                                    {{ n.srfr_claim_code }}
                                                </v-chip>
                                                <br />
                                                <v-chip
                                                    x-small
                                                    class="mt-1"
                                                    color="amber"
                                                >
                                                    {{ n.srfr_claim_rma }}
                                                </v-chip>
                                                <br />
                                                <v-chip
                                                    x-small
                                                    class="mt-1 mb-1"
                                                >
                                                    {{ n.srfr_claim_date }}
                                                </v-chip>
                                            </td>
                                        </tr>
                                        <br />
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                    </v-row>
                </div>
            </v-card>
        </v-container>

        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <v-toolbar-title>HISTORY</v-toolbar-title>
                    </v-toolbar>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-row>
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Qty
                                                        </th>
                                                        <th class="text-center">
                                                            Date Send
                                                        </th>
                                                        <th
                                                            class="text-center"
                                                        ></th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr
                                                        v-for="(rClaim,
                                                        ii) in data_claim"
                                                        :key="ii"
                                                    >
                                                        <td class="text-center">
                                                            {{ ii + 1 }}.
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                rClaim
                                                                    .transfer_detail
                                                                    .length
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                rClaim.created_date
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-btn
                                                                fab
                                                                small
                                                                @click="
                                                                    print(
                                                                        rClaim.transfer_id
                                                                    )
                                                                "
                                                            >
                                                                <v-icon
                                                                    >mdi-printer</v-icon
                                                                >
                                                            </v-btn>

                                                            <v-tooltip top>
                                                                <template
                                                                    v-slot:activator="{
                                                                        on,
                                                                        attrs,
                                                                    }"
                                                                >
                                                                    <v-btn
                                                                        fab
                                                                        small
                                                                        :color="
                                                                            chk_export_data[
                                                                                ii
                                                                            ] !=
                                                                            true
                                                                                ? 'green accent-3'
                                                                                : ''
                                                                        "
                                                                        :disabled="
                                                                            chk_export_data[
                                                                                ii
                                                                            ] ==
                                                                                true
                                                                        "
                                                                        class="ml-1"
                                                                        @click="
                                                                            func_export(
                                                                                rClaim.transfer_id,
                                                                                ii
                                                                            )
                                                                        "
                                                                        v-bind="
                                                                            attrs
                                                                        "
                                                                        v-on="
                                                                            on
                                                                        "
                                                                    >
                                                                        <v-icon
                                                                            v-if="
                                                                                chk_export_data[
                                                                                    ii
                                                                                ] !=
                                                                                    true
                                                                            "
                                                                            color="teal darken-4"
                                                                            >mdi-file-excel</v-icon
                                                                        >
                                                                        <img
                                                                            v-if="
                                                                                chk_export_data[
                                                                                    ii
                                                                                ] ==
                                                                                    true
                                                                            "
                                                                            src="../../assets/all/Loading.gif"
                                                                            style="width: 6%;"
                                                                        />
                                                                    </v-btn>
                                                                </template>
                                                                <span
                                                                    >Export
                                                                    Data</span
                                                                >
                                                            </v-tooltip>
                                                        </td>
                                                    </tr>
                                                    <br />
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-row>

        <v-row justify="center">
            <v-dialog
                v-model="dialog_pending"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>

                        <v-toolbar-title>VIEW PENDING</v-toolbar-title>
                    </v-toolbar>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-row>
                                    <v-col cols="12">
                                        <v-simple-table class="table-inv">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr class="col-tr-1">
                                                        <th class="text-center">
                                                            #
                                                        </th>
                                                        <th class="text-center">
                                                            Branch
                                                        </th>
                                                        <th class="text-center">
                                                            Detail
                                                        </th>
                                                        <th class="text-center">
                                                            CaseID
                                                        </th>
                                                        <th class="text-center">
                                                            Job Type
                                                        </th>
                                                        <th class="text-center">
                                                            Engineer
                                                        </th>
                                                        <th class="text-center">
                                                            Onsite Date
                                                        </th>
                                                        <th class="text-center">
                                                            Solution
                                                        </th>
                                                        <th class="text-center">
                                                            Booking
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr
                                                        v-for="(row_p,
                                                        index_p) in data_pending"
                                                        :key="index_p"
                                                    >
                                                        <td class="text-center">
                                                            {{ index_p + 1 }}.
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row_p.branch_name
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                x-small
                                                                color="orange lighten-3"
                                                            >
                                                                {{
                                                                    row_p.part_name
                                                                }}
                                                            </v-chip>
                                                            <br />
                                                            <v-chip
                                                                x-small
                                                                color="teal lighten-3"
                                                                class="mt-1"
                                                            >
                                                                {{
                                                                    row_p.singlepart
                                                                }}
                                                            </v-chip>
                                                        </td>
                                                        <td class="text-center">
                                                            {{ row_p.case_id }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                row_p.case_type
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{
                                                                row_p.engineer_name
                                                            }}
                                                        </td>
                                                        <td class="text-center">
                                                            {{
                                                                row_p.onsite_date
                                                            }}
                                                        </td>
                                                        <td>
                                                            {{ row_p.solution }}
                                                        </td>
                                                        <td class="text-center">
                                                            <v-chip
                                                                x-small
                                                                class="mt-1"
                                                                color="amber"
                                                                v-if="
                                                                    row_p.booking_name
                                                                "
                                                            >
                                                                {{
                                                                    row_p.booking_name
                                                                }}
                                                            </v-chip>
                                                            <br />
                                                            <v-chip
                                                                x-small
                                                                class="mt-1 mb-1"
                                                                v-if="
                                                                    row_p.booking_date
                                                                "
                                                            >
                                                                {{
                                                                    row_p.booking_date
                                                                }}
                                                            </v-chip>
                                                        </td>
                                                    </tr>
                                                    <br />
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-col>
                                </v-row>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card>
            </v-dialog>
        </v-row>
        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>
    </div>
</template>

<script>
import axios from "axios"

import { mapState, mapMutations } from "vuex"

const url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    computed: {
        ...mapState(["snackbar"]),
        ...mapState(["isLoading"]),
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        ...mapMutations(["mutateIsLoading"]),
        async get_data() {
            this.mutateIsLoading()
            await axios
                .get(url + "srfr/defective/", this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.data_main = response.data
                    this.data_main_search = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        all() {
            if (this.colorx == "") {
                this.colorx = "success"
                this.data_main.map((r) => {
                    this.checkbox.push(r.defective_id)
                })
            } else {
                this.colorx = ""
                this.checkbox = []
            }
        },
        async save() {
            this.mutateIsLoading()
            let data_save = {
                defective_id: this.checkbox,
            }
            await axios
                .post(url + "srfr/defective/", data_save, this.tk)
                .then((response) => {
                    this.colorx = ""
                    this.checkbox = []
                    this.form_search_case = ""
                    this.mutateIsLoading()
                    this.mutatesnackbar()
                    this.get_data()
                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        print(transfer_id) {
            let url_print = "/Inventory/Defective-Toner/Print/" + transfer_id
            this.$router.push(url_print)
        },
        func_export(transfer_id, ii) {
            this.chk_export_data[ii] = true
            axios({
                url:
                    `${process.env.VUE_APP_ROOT_API}/api/srfr/sent-claim/export/` +
                    transfer_id,
                method: "GET",
                responseType: "blob",
                ...this.tk,
            }).then((response) => {
                this.chk_export_data[ii] = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute(
                    "download",
                    "ARC_supplies_request_form.xlsx"
                )
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },

        async export_data() {
            this.dialog_loading = true
            await axios({
                url: url + "srfr/export/pending",
                method: "GET",
                responseType: "blob",
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.dialog_loading = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "file.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        async get_history() {
            this.mutateIsLoading()
            await axios
                .get(url + "srfr/sent-claim/", this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.dialog = true
                    this.data_claim = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_pending() {
            this.mutateIsLoading()
            await axios
                .get(url + "srfr/view-pending/", this.tk)
                .then((response) => {
                    this.mutateIsLoading()
                    this.dialog_pending = true
                    this.data_pending = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        close() {
            this.dialog = false
            this.dialog_pending = false
        },
        func_search_case() {
            if (this.form_search_case.length >= 5) {
                this.data_main_search.map((each, index) => {
                    if (
                        this.form_search_case == each.case_id ||
                        this.form_search_case == each.singlepart ||
                        this.form_search_case == each.srfr_claim_rma
                    ) {
                        if (this.checkbox.indexOf(each.defective_id) < 0) {
                            if (this.team_name == "ODM") {
                                this.$swal({
                                    title: `Singlepart : ${each.singlepart}`,
                                    text: `case id : ${each.case_id} | partname : ${each.part_name} | claim rma : ${each.srfr_claim_rma}`,
                                    icon: "success",
                                    // button: true,
                                    timer: 2000,
                                })
                            } else {
                                this.$swal({
                                    title: `Singlepart : ${each.singlepart}`,
                                    text: `case id : ${each.case_id} | partname : ${each.part_name} | claim rma : ${each.srfr_claim_rma}`,
                                    icon: "success",
                                    button: true,
                                    // timer: 2000,
                                })
                            }

                            this.form_search_case = ""
                            this.checkbox.push(each.defective_id)
                        }
                    }
                })
            }
        },
        uppercase() {
            this.form_search_case = this.form_search_case.toUpperCase()
        },
    },
    data() {
        return {
            dialog_loading: false,
            team_name: localStorage.team_name,
            role_name: localStorage.role_name,
            data_main_search: [],
            form_search_case: "",
            dialog: false,
            checkbox: [],
            colorx: "",
            data_main: [],
            data_claim: [],
            form: {
                supplier_id: [],
            },
            text: "Success, Your work has been saved",
            tk: null,
            chk_export_data: [],
            dialog_pending: false,
            data_pending: [],
        }
    },
}
</script>
